// extracted by mini-css-extract-plugin
module.exports = {"inputImage":"VehicleDeviationPhotoInput_inputImage_2Cfgo"};